import React from 'react';
import DetailItem from './DetailItem';
import OriginalSize from './OriginalSize';
import { deviationHasFileSizeMetadata } from './helpers';
import { PapiDeviation } from '@wix/da-papi-types';

export interface Props {
  deviation: PapiDeviation;
}

export const DetailItemList: React.FC<Props> = ({ deviation }) => {
  const exif = deviation?.extended?.exif ?? [];

  const hasDetails = exif.length > 0 || deviationHasFileSizeMetadata(deviation);

  if (!hasDetails) {
    return null;
  }

  return (
    <>
      <OriginalSize deviation={deviation} />
      {exif.map(({ tag, value }) => (
        <DetailItem key={tag} name={tag} value={value} transPrefix="exif." />
      ))}
    </>
  );
};
DetailItemList.displayName = 'DetailItemList';

export default DetailItemList;
